import { render, staticRenderFns } from "./NewFundBuyProgress.vue?vue&type=template&id=6f754fe6&scoped=true&"
import script from "./NewFundBuyProgress.vue?vue&type=script&lang=js&"
export * from "./NewFundBuyProgress.vue?vue&type=script&lang=js&"
import style0 from "./NewFundBuyProgress.vue?vue&type=style&index=0&id=6f754fe6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f754fe6",
  null
  
)

export default component.exports